import { cryptoSubtle, getCryptoRandomValues } from './windowUtils';

const dec2hex = (dec: any) => {
    return ('0' + dec.toString(16)).substr(-2);
};

const sha256 = (plain: string) => {
    // returns promise ArrayBuffer
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return cryptoSubtle().digest('SHA-256', data);
};

const base64urlencode = (a: ArrayBuffer): string => {
    let str = '';
    const bytes = new Uint8Array(a);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        str += String.fromCharCode(bytes[i]);
    }
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const generateCodeVerifier = (): string => {
    const array = new Uint32Array(56 / 2);
    getCryptoRandomValues(array);
    return Array.from(array, dec2hex).join('');
};

export const generateCodeChallengeFromVerifier = async (
    codeVerifier: string
) => {
    const hashed = await sha256(codeVerifier);
    const base64encoded = base64urlencode(hashed);
    return base64encoded;
};
